export const routing =
  {
    "deployment"        : false,
    "routeToServer"     : 'dr1'
  }
